/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** Object describing a single geographical point. */
  GeoJSONPoint: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AddGridConsumption = {
  devices?: InputMaybe<Array<InputMaybe<BuildingGridConsumptionInput>>>;
};

export type AddGridMain = {
  current: Scalars['Int']['input'];
  deviceId: Scalars['ID']['input'];
  maxPower: Scalars['Int']['input'];
  phases: Scalars['Int']['input'];
};

export type AddSolar = {
  devices?: InputMaybe<Array<InputMaybe<GridSolarDeviceInput>>>;
};

export type AddStorage = {
  devices: Array<InputMaybe<BuildingGridStorageInput>>;
};

export type Building = {
  __typename?: 'Building';
  address?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  bucketId?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Array<Maybe<Device>>>;
  gatewayBucketToken?: Maybe<Scalars['String']['output']>;
  gateways?: Maybe<Array<Maybe<Gateway>>>;
  grafanaBucketToken?: Maybe<Scalars['String']['output']>;
  grid?: Maybe<BuildingGrid>;
  location?: Maybe<Scalars['GeoJSONPoint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<BuildingPreferences>;
  sensorDataCollection?: Maybe<Scalars['String']['output']>;
  smartCharging?: Maybe<SmartChargingPreferences>;
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BuildingGrid = {
  __typename?: 'BuildingGrid';
  consumption?: Maybe<Array<Maybe<BuildingGridConsumption>>>;
  distributionBoxes?: Maybe<Array<Maybe<GridDistributionBox>>>;
  groups?: Maybe<Array<Maybe<DeviceGroup>>>;
  main?: Maybe<Array<Maybe<BuildingGridMain>>>;
  solar?: Maybe<Array<Maybe<GridSolarDevice>>>;
  storage?: Maybe<Array<Maybe<BuildingGridStorage>>>;
};

export type BuildingGridConsumption = {
  __typename?: 'BuildingGridConsumption';
  capacityWh?: Maybe<Scalars['Int']['output']>;
  deviceId: Scalars['ID']['output'];
  maxCurrent?: Maybe<Scalars['Int']['output']>;
  maxPower?: Maybe<Scalars['Int']['output']>;
  phases?: Maybe<Scalars['Int']['output']>;
};

export type BuildingGridConsumptionInput = {
  capacityWh?: InputMaybe<Scalars['Int']['input']>;
  deviceId: Scalars['ID']['input'];
  maxCurrent?: InputMaybe<Scalars['Int']['input']>;
  maxPower?: InputMaybe<Scalars['Int']['input']>;
  phases?: InputMaybe<Scalars['Int']['input']>;
};

export type BuildingGridMain = {
  __typename?: 'BuildingGridMain';
  current?: Maybe<Scalars['Int']['output']>;
  deviceId?: Maybe<Scalars['ID']['output']>;
  maxPower?: Maybe<Scalars['Int']['output']>;
  phases?: Maybe<Scalars['Int']['output']>;
};

export type BuildingGridStorage = {
  __typename?: 'BuildingGridStorage';
  capacityWh?: Maybe<Scalars['Int']['output']>;
  deviceId?: Maybe<Scalars['ID']['output']>;
  maxCurrent?: Maybe<Scalars['Int']['output']>;
  maxPower?: Maybe<Scalars['Int']['output']>;
  phases?: Maybe<Scalars['Int']['output']>;
};

export type BuildingGridStorageInput = {
  capacityWh?: InputMaybe<Scalars['Int']['input']>;
  deviceId: Scalars['ID']['input'];
  maxCurrent?: InputMaybe<Scalars['Int']['input']>;
  maxPower?: InputMaybe<Scalars['Int']['input']>;
  phases?: InputMaybe<Scalars['Int']['input']>;
};

export type BuildingMetadataResult = {
  __typename?: 'BuildingMetadataResult';
  buildingId?: Maybe<Scalars['String']['output']>;
};

export type BuildingPreferences = {
  __typename?: 'BuildingPreferences';
  defaultScreen?: Maybe<Scalars['String']['output']>;
  hasGrid?: Maybe<Scalars['Boolean']['output']>;
  hasMonitoring?: Maybe<Scalars['Boolean']['output']>;
  hasSmartCharging?: Maybe<Scalars['Boolean']['output']>;
};

export type CodeLogin = {
  __typename?: 'CodeLogin';
  token?: Maybe<Scalars['String']['output']>;
};

export type CreateBuildingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  defaultScreen?: InputMaybe<Scalars['String']['input']>;
  hasGrid?: InputMaybe<Scalars['Boolean']['input']>;
  hasMonitoring?: InputMaybe<Scalars['Boolean']['input']>;
  hasSmartCharging?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CreateCustomerInput = {
  billingAddress: CustomerAddressInput;
  billingEmail: Scalars['String']['input'];
  kvk: Scalars['String']['input'];
  name: Scalars['String']['input'];
  psp?: InputMaybe<CreateCustomerPspInput>;
  shippingAddress?: InputMaybe<CustomerAddressInput>;
};

export type CreateCustomerPspInput = {
  invoicePrefix: Scalars['String']['input'];
  psp: Scalars['String']['input'];
  pspId: Scalars['String']['input'];
};

export type CreateGatewayInput = {
  type: GatewayType;
};

export type Customer = {
  __typename?: 'Customer';
  billingAddress?: Maybe<CustomerAddress>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<CustomerBranding>;
  buildings?: Maybe<Array<Maybe<Building>>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  grafanaOrganisationId?: Maybe<Scalars['Int']['output']>;
  kvk?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<CustomerPaymentDetails>;
  psp?: Maybe<CustomerPsp>;
  /** @deprecated Field no longer supported */
  sensorDataCredentials?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<CustomerAddress>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
};

export type CustomerAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  province?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerBranding = {
  __typename?: 'CustomerBranding';
  logo?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  signageBackgroundImage?: Maybe<Scalars['String']['output']>;
  tertiaryColor?: Maybe<Scalars['String']['output']>;
};

export type CustomerBrandingInput = {
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerForDomainDetails = {
  __typename?: 'CustomerForDomainDetails';
  authOrganisationId: Scalars['String']['output'];
};

export type CustomerPaymentDetails = {
  __typename?: 'CustomerPaymentDetails';
  delinquent?: Maybe<Scalars['Boolean']['output']>;
  paymentPortal?: Maybe<Scalars['String']['output']>;
  subscriptionStatus?: Maybe<SubscriptionPaymentStatus>;
};

export type CustomerPsp = {
  __typename?: 'CustomerPsp';
  invoicePrefix?: Maybe<Scalars['String']['output']>;
  psp: Scalars['String']['output'];
  pspId: Scalars['String']['output'];
};

export type Device = {
  __typename?: 'Device';
  applicationId?: Maybe<Scalars['String']['output']>;
  building?: Maybe<Building>;
  cType?: Maybe<Scalars['String']['output']>;
  cTypeC?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  data?: Maybe<Array<Maybe<SensorValue>>>;
  devEUI?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  eType?: Maybe<Scalars['String']['output']>;
  gatewayId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<DeviceProperties>;
  section?: Maybe<Section>;
  source: DeviceSource;
  status?: Maybe<DeviceStatus>;
  symconId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type DeviceCreateInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  buildingId: Scalars['String']['input'];
  cType?: InputMaybe<Scalars['String']['input']>;
  cTypeC?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  devEUI?: InputMaybe<Scalars['String']['input']>;
  eType?: InputMaybe<Scalars['String']['input']>;
  gatewayId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  source: DeviceSource;
  symconId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
};

export type DeviceEditInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  cType?: InputMaybe<Scalars['String']['input']>;
  cTypeC?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  devEUI?: InputMaybe<Scalars['String']['input']>;
  eType?: InputMaybe<Scalars['String']['input']>;
  gatewayId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<DeviceSource>;
  symconId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceGroup = {
  __typename?: 'DeviceGroup';
  buildingId?: Maybe<Scalars['ID']['output']>;
  devices?: Maybe<Array<Maybe<Device>>>;
  groupId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DeviceGroupInput = {
  buildingId: Scalars['ID']['input'];
  devices?: InputMaybe<Array<InputMaybe<GroupDevicesInput>>>;
  title: Scalars['String']['input'];
};

export type DeviceProperties = {
  __typename?: 'DeviceProperties';
  maxLoad?: Maybe<Scalars['Int']['output']>;
  phases?: Maybe<Scalars['Int']['output']>;
};

export enum DeviceSource {
  Lite = 'lite',
  Symcon = 'symcon',
  Tti = 'tti'
}

export enum DeviceStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export type EditBuildingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  defaultScreen?: InputMaybe<Scalars['String']['input']>;
  hasGrid?: InputMaybe<Scalars['Boolean']['input']>;
  hasMonitoring?: InputMaybe<Scalars['Boolean']['input']>;
  hasSmartCharging?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EditCustomerInput = {
  billingAddress?: InputMaybe<CustomerAddressInput>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  branding?: InputMaybe<CustomerBrandingInput>;
  shippingAddress?: InputMaybe<CustomerAddressInput>;
};

export type Gateway = {
  __typename?: 'Gateway';
  buildingId?: Maybe<Scalars['ID']['output']>;
  gatewayId?: Maybe<Scalars['ID']['output']>;
  gatewayKey?: Maybe<Scalars['String']['output']>;
  gatewaySecret?: Maybe<Scalars['String']['output']>;
  qrcode?: Maybe<Scalars['String']['output']>;
  qrcodeInclusion?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<GatewayType>;
};

export enum GatewayType {
  Lite = 'lite',
  Server = 'server'
}

export type GetDeltaForPeriodInput = {
  devices?: InputMaybe<Array<Scalars['ID']['input']>>;
  end: Scalars['String']['input'];
  measurement: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type GetDeltaForWindowInput = {
  devices?: InputMaybe<Array<Scalars['ID']['input']>>;
  end: Scalars['String']['input'];
  fn?: InputMaybe<Scalars['String']['input']>;
  measurement: Scalars['String']['input'];
  start: Scalars['String']['input'];
  window: Scalars['String']['input'];
};

export type GetDeviceInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  devEUI?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  symconId?: InputMaybe<Scalars['String']['input']>;
};

export type GetMinMaxForPeriodInput = {
  deviceId: Scalars['ID']['input'];
  end: Scalars['String']['input'];
  measurement: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type GridDistributionBox = {
  __typename?: 'GridDistributionBox';
  building?: Maybe<Building>;
  circuits?: Maybe<Array<Maybe<GridDistributionCircuit>>>;
  description?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Device>;
  distributionBoxId?: Maybe<Scalars['ID']['output']>;
  maxCurrent?: Maybe<Scalars['Int']['output']>;
  maxCurrentPerPhase?: Maybe<Scalars['Int']['output']>;
  maxPower?: Maybe<Scalars['Int']['output']>;
  maxPowerPerPhase?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<GridDistributionBox>;
};

export type GridDistributionBoxInput = {
  buildingId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  maxCurrent: Scalars['Int']['input'];
  maxCurrentPerPhase: Scalars['Int']['input'];
  maxPower: Scalars['Int']['input'];
  maxPowerPerPhase: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type GridDistributionCircuit = {
  __typename?: 'GridDistributionCircuit';
  children?: Maybe<Array<Maybe<GridDistributionCircuit>>>;
  circuitId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Device>;
  gridDistributionBox?: Maybe<GridDistributionBox>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<GridDistributionCircuit>;
};

export type GridDistributionCircuitInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['ID']['input'];
  gridDistributionBoxId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type GridSolarDevice = {
  __typename?: 'GridSolarDevice';
  deviceId: Scalars['ID']['output'];
  maxCurrent?: Maybe<Scalars['Int']['output']>;
  maxPower?: Maybe<Scalars['Int']['output']>;
  phases?: Maybe<Scalars['Int']['output']>;
};

export type GridSolarDeviceInput = {
  deviceId: Scalars['ID']['input'];
  maxCurrent?: InputMaybe<Scalars['Int']['input']>;
  maxPower?: InputMaybe<Scalars['Int']['input']>;
  phases?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupDevicesInput = {
  deviceId: Scalars['ID']['input'];
};

export type LinkConfirmation = {
  __typename?: 'LinkConfirmation';
  branding?: Maybe<SignageBranding>;
  buildingId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type LinkGatewayBuildingInput = {
  buildingId: Scalars['ID']['input'];
  gatewayKey: Scalars['String']['input'];
  gatewaySecret: Scalars['String']['input'];
};

export type LinkSignageInput = {
  buildingId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};

export type LinkingCode = {
  __typename?: 'LinkingCode';
  code: Scalars['String']['output'];
};

export type LinkingStatus = {
  __typename?: 'LinkingStatus';
  status?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  addConsumption?: Maybe<Building>;
  addGridMain?: Maybe<Building>;
  addSolar?: Maybe<Building>;
  addStorage?: Maybe<Building>;
  createBuilding?: Maybe<Building>;
  createCustomer?: Maybe<Customer>;
  createDevice?: Maybe<Device>;
  createGateway?: Maybe<Gateway>;
  createGridDeviceGroup?: Maybe<DeviceGroup>;
  createGridDistributionBox?: Maybe<GridDistributionBox>;
  createGridDistributionCircuit?: Maybe<GridDistributionCircuit>;
  createSection?: Maybe<Section>;
  editBuilding?: Maybe<Building>;
  editDevice?: Maybe<MutationResponse>;
  editMyCustomer?: Maybe<Customer>;
  linkGatewayToBuilding?: Maybe<Scalars['Boolean']['output']>;
  linkSignageToBuilding?: Maybe<LinkingStatus>;
  requestLinkingCode?: Maybe<LinkingCode>;
  validateLinkingCode?: Maybe<LinkingStatus>;
};


export type MutationAddConsumptionArgs = {
  buildingId: Scalars['ID']['input'];
  input?: InputMaybe<AddGridConsumption>;
};


export type MutationAddGridMainArgs = {
  buildingId: Scalars['ID']['input'];
  input?: InputMaybe<AddGridMain>;
};


export type MutationAddSolarArgs = {
  buildingId: Scalars['ID']['input'];
  input?: InputMaybe<AddSolar>;
};


export type MutationAddStorageArgs = {
  buildingId: Scalars['ID']['input'];
  input?: InputMaybe<AddStorage>;
};


export type MutationCreateBuildingArgs = {
  input?: InputMaybe<CreateBuildingInput>;
};


export type MutationCreateCustomerArgs = {
  input?: InputMaybe<CreateCustomerInput>;
};


export type MutationCreateDeviceArgs = {
  input?: InputMaybe<DeviceCreateInput>;
};


export type MutationCreateGatewayArgs = {
  input?: InputMaybe<CreateGatewayInput>;
};


export type MutationCreateGridDeviceGroupArgs = {
  input?: InputMaybe<DeviceGroupInput>;
};


export type MutationCreateGridDistributionBoxArgs = {
  input?: InputMaybe<GridDistributionBoxInput>;
};


export type MutationCreateGridDistributionCircuitArgs = {
  input?: InputMaybe<GridDistributionCircuitInput>;
};


export type MutationCreateSectionArgs = {
  input?: InputMaybe<SectionInput>;
};


export type MutationEditBuildingArgs = {
  buildingId: Scalars['ID']['input'];
  input?: InputMaybe<EditBuildingInput>;
};


export type MutationEditDeviceArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<DeviceEditInput>;
};


export type MutationEditMyCustomerArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<EditCustomerInput>;
};


export type MutationLinkGatewayToBuildingArgs = {
  input?: InputMaybe<LinkGatewayBuildingInput>;
};


export type MutationLinkSignageToBuildingArgs = {
  input?: InputMaybe<LinkSignageInput>;
};


export type MutationValidateLinkingCodeArgs = {
  code: Scalars['String']['input'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<Gateway>;
  gateways?: Maybe<Array<Maybe<Gateway>>>;
  getAvailableCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getAvailableTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getBuilding?: Maybe<Building>;
  getBuildingLayout?: Maybe<Array<Maybe<Section>>>;
  getBuildingsForCustomer?: Maybe<Array<Maybe<Building>>>;
  getCustomerDetails?: Maybe<Customer>;
  getDeltaForPeriod?: Maybe<Scalars['JSON']['output']>;
  getDeltaForWindow?: Maybe<Scalars['JSON']['output']>;
  getDevice?: Maybe<Device>;
  getDevicesWithCategory?: Maybe<Array<Maybe<Device>>>;
  getDevicesWithTag?: Maybe<Array<Maybe<Device>>>;
  getGridDeviceGroups?: Maybe<Array<Maybe<DeviceGroup>>>;
  getGridDistributionBox?: Maybe<GridDistributionBox>;
  getGridDistributionCircuit?: Maybe<GridDistributionCircuit>;
  getMinMaxForPeriod?: Maybe<Scalars['JSON']['output']>;
  getMyBuildings?: Maybe<Array<Maybe<Building>>>;
  getMyCustomerDetails?: Maybe<Customer>;
  getMyCustomers?: Maybe<Array<Maybe<Customer>>>;
  getOrganisationForDomain?: Maybe<CustomerForDomainDetails>;
  getSection?: Maybe<Section>;
  getWindowedMeasurements?: Maybe<Scalars['JSON']['output']>;
  me?: Maybe<User>;
  pushLayoutToGateway?: Maybe<Scalars['Boolean']['output']>;
};


export type QueryGatewayArgs = {
  gatewayId: Scalars['ID']['input'];
};


export type QueryGetAvailableCategoriesArgs = {
  buildingId: Scalars['ID']['input'];
};


export type QueryGetAvailableTagsArgs = {
  buildingId: Scalars['ID']['input'];
};


export type QueryGetBuildingArgs = {
  buildingId: Scalars['ID']['input'];
};


export type QueryGetBuildingLayoutArgs = {
  buildingId: Scalars['ID']['input'];
};


export type QueryGetCustomerDetailsArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryGetDeltaForPeriodArgs = {
  input?: InputMaybe<GetDeltaForPeriodInput>;
};


export type QueryGetDeltaForWindowArgs = {
  input?: InputMaybe<GetDeltaForWindowInput>;
};


export type QueryGetDeviceArgs = {
  input?: InputMaybe<GetDeviceInput>;
};


export type QueryGetDevicesWithCategoryArgs = {
  buildingId: Scalars['ID']['input'];
  category: Scalars['String']['input'];
};


export type QueryGetDevicesWithTagArgs = {
  buildingId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};


export type QueryGetGridDeviceGroupsArgs = {
  buildingId: Scalars['ID']['input'];
};


export type QueryGetGridDistributionBoxArgs = {
  distributionBoxId: Scalars['ID']['input'];
};


export type QueryGetGridDistributionCircuitArgs = {
  circuitId: Scalars['ID']['input'];
};


export type QueryGetMinMaxForPeriodArgs = {
  input?: InputMaybe<GetMinMaxForPeriodInput>;
};


export type QueryGetOrganisationForDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryGetSectionArgs = {
  sectionId: Scalars['ID']['input'];
};


export type QueryGetWindowedMeasurementsArgs = {
  input?: InputMaybe<WindowedMeasurementsInput>;
};


export type QueryPushLayoutToGatewayArgs = {
  buildingId: Scalars['ID']['input'];
};

export enum Role {
  Anonymous = 'Anonymous',
  OrgAdmin = 'OrgAdmin',
  SuperUser = 'SuperUser',
  User = 'User',
  Viewer = 'Viewer'
}

export type Section = {
  __typename?: 'Section';
  devices?: Maybe<Array<Maybe<Device>>>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  sectionId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SectionInput = {
  buildingId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  type: Scalars['String']['input'];
};

export type SensorUpdate = {
  __typename?: 'SensorUpdate';
  data?: Maybe<Array<Maybe<SensorValue>>>;
  deviceId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type SensorValue = {
  __typename?: 'SensorValue';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type SignageBranding = {
  __typename?: 'SignageBranding';
  logo?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  signageBackgroundImage?: Maybe<Scalars['String']['output']>;
  tertiaryColor?: Maybe<Scalars['String']['output']>;
};

export type SmartChargingBranding = {
  __typename?: 'SmartChargingBranding';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  buttonActiveBackgroundColor?: Maybe<Scalars['String']['output']>;
  buttonBackgroundColor?: Maybe<Scalars['String']['output']>;
  chartMetricColor?: Maybe<Scalars['String']['output']>;
  chartTotalColor?: Maybe<Scalars['String']['output']>;
  infoBackgroundColor?: Maybe<Scalars['String']['output']>;
  introColor?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  metricFontColor?: Maybe<Scalars['String']['output']>;
  titleColor?: Maybe<Scalars['String']['output']>;
  topBarBackgroundColor?: Maybe<Scalars['String']['output']>;
};

export type SmartChargingPreferences = {
  __typename?: 'SmartChargingPreferences';
  branding?: Maybe<SmartChargingBranding>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _empty?: Maybe<Scalars['String']['output']>;
  sensorUpdate?: Maybe<SensorUpdate>;
  signageLinking?: Maybe<LinkConfirmation>;
};


export type SubscriptionSensorUpdateArgs = {
  devices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubscriptionSignageLinkingArgs = {
  code: Scalars['String']['input'];
};

export enum SubscriptionPaymentStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export type User = {
  __typename?: 'User';
  customer?: Maybe<Customer>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type WindowedMeasurementsInput = {
  deviceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  end: Scalars['String']['input'];
  fn?: InputMaybe<Scalars['String']['input']>;
  measurement: Scalars['String']['input'];
  start: Scalars['String']['input'];
  window: Scalars['String']['input'];
};

export type GetBuildingGridQueryVariables = Exact<{
  buildingId: Scalars['ID']['input'];
}>;


export type GetBuildingGridQuery = { __typename?: 'Query', getBuilding?: { __typename?: 'Building', grid?: { __typename?: 'BuildingGrid', distributionBoxes?: Array<{ __typename?: 'GridDistributionBox', distributionBoxId?: string | null, name?: string | null, parent?: { __typename?: 'GridDistributionBox', distributionBoxId?: string | null } | null } | null> | null } | null } | null };

export type GetExtendedBuildingGridQueryVariables = Exact<{
  buildingId: Scalars['ID']['input'];
}>;


export type GetExtendedBuildingGridQuery = { __typename?: 'Query', getBuilding?: { __typename?: 'Building', grid?: { __typename?: 'BuildingGrid', main?: Array<{ __typename?: 'BuildingGridMain', current?: number | null, maxPower?: number | null, deviceId?: string | null, phases?: number | null } | null> | null, distributionBoxes?: Array<{ __typename?: 'GridDistributionBox', description?: string | null, distributionBoxId?: string | null, name?: string | null, circuits?: Array<{ __typename?: 'GridDistributionCircuit', circuitId?: string | null } | null> | null, parent?: { __typename?: 'GridDistributionBox', distributionBoxId?: string | null } | null, device?: { __typename?: 'Device', deviceId: string, name?: string | null, type: string, source: DeviceSource, data?: Array<{ __typename?: 'SensorValue', key?: string | null, value?: number | null } | null> | null } | null } | null> | null } | null } | null };

export type GetGridForPowerOverviewQueryVariables = Exact<{
  buildingId: Scalars['ID']['input'];
}>;


export type GetGridForPowerOverviewQuery = { __typename?: 'Query', getBuilding?: { __typename?: 'Building', grid?: { __typename?: 'BuildingGrid', main?: Array<{ __typename?: 'BuildingGridMain', deviceId?: string | null } | null> | null, solar?: Array<{ __typename?: 'GridSolarDevice', deviceId: string } | null> | null, storage?: Array<{ __typename?: 'BuildingGridStorage', deviceId?: string | null } | null> | null, consumption?: Array<{ __typename?: 'BuildingGridConsumption', deviceId: string } | null> | null } | null } | null };

export type GetAvailableCategoriesQueryVariables = Exact<{
  buildingId: Scalars['ID']['input'];
}>;


export type GetAvailableCategoriesQuery = { __typename?: 'Query', getAvailableCategories?: Array<string | null> | null };

export type GetDeviceTypeQueryVariables = Exact<{
  input?: InputMaybe<GetDeviceInput>;
}>;


export type GetDeviceTypeQuery = { __typename?: 'Query', getDevice?: { __typename?: 'Device', type: string, deviceId: string } | null };

export type GetDevicesWithCategoryQueryVariables = Exact<{
  buildingId: Scalars['ID']['input'];
  category: Scalars['String']['input'];
}>;


export type GetDevicesWithCategoryQuery = { __typename?: 'Query', getDevicesWithCategory?: Array<{ __typename?: 'Device', deviceId: string, name?: string | null, type: string } | null> | null };

export type GridDistributionCircuitFragmentFragment = { __typename?: 'GridDistributionCircuit', circuitId?: string | null, name?: string | null, description?: string | null, label?: string | null, device?: { __typename?: 'Device', deviceId: string, type: string, name?: string | null, status?: DeviceStatus | null, source: DeviceSource, data?: Array<{ __typename?: 'SensorValue', key?: string | null, value?: number | null } | null> | null } | null } & { ' $fragmentName'?: 'GridDistributionCircuitFragmentFragment' };

export type GetGridDistributionBoxQueryVariables = Exact<{
  distributionBoxId: Scalars['ID']['input'];
}>;


export type GetGridDistributionBoxQuery = { __typename?: 'Query', getGridDistributionBox?: { __typename?: 'GridDistributionBox', name?: string | null, description?: string | null, distributionBoxId?: string | null, maxPower?: number | null, maxCurrent?: number | null, maxPowerPerPhase?: number | null, maxCurrentPerPhase?: number | null, parent?: { __typename?: 'GridDistributionBox', name?: string | null } | null, building?: { __typename?: 'Building', name?: string | null } | null, device?: { __typename?: 'Device', deviceId: string, type: string } | null, circuits?: Array<(
      { __typename?: 'GridDistributionCircuit', parent?: (
        { __typename?: 'GridDistributionCircuit', parent?: (
          { __typename?: 'GridDistributionCircuit', parent?: (
            { __typename?: 'GridDistributionCircuit' }
            & { ' $fragmentRefs'?: { 'GridDistributionCircuitFragmentFragment': GridDistributionCircuitFragmentFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'GridDistributionCircuitFragmentFragment': GridDistributionCircuitFragmentFragment } }
        ) | null }
        & { ' $fragmentRefs'?: { 'GridDistributionCircuitFragmentFragment': GridDistributionCircuitFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'GridDistributionCircuitFragmentFragment': GridDistributionCircuitFragmentFragment } }
    ) | null> | null } | null };

export type FetchDeltaForPeriodQueryVariables = Exact<{
  input?: InputMaybe<GetDeltaForPeriodInput>;
}>;


export type FetchDeltaForPeriodQuery = { __typename?: 'Query', getDeltaForPeriod?: any | null };

export type GetMinMaxForPeriodQueryVariables = Exact<{
  input?: InputMaybe<GetMinMaxForPeriodInput>;
}>;


export type GetMinMaxForPeriodQuery = { __typename?: 'Query', getMinMaxForPeriod?: any | null };

export type GetWindowedMeasurementsQueryVariables = Exact<{
  input?: InputMaybe<WindowedMeasurementsInput>;
}>;


export type GetWindowedMeasurementsQuery = { __typename?: 'Query', getWindowedMeasurements?: any | null };

export type GetDeltaForWindowQueryVariables = Exact<{
  input?: InputMaybe<GetDeltaForWindowInput>;
}>;


export type GetDeltaForWindowQuery = { __typename?: 'Query', getDeltaForWindow?: any | null };

export type GetBuildingsForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuildingsForUserQuery = { __typename?: 'Query', me?: { __typename?: 'User', customer?: { __typename?: 'Customer', name?: string | null, customerId?: string | null, buildings?: Array<{ __typename?: 'Building', name?: string | null, buildingId?: string | null, preferences?: { __typename?: 'BuildingPreferences', hasGrid?: boolean | null, hasMonitoring?: boolean | null, hasSmartCharging?: boolean | null } | null } | null> | null } | null } | null };

export type GetBuildingQueryVariables = Exact<{
  buildingId: Scalars['ID']['input'];
}>;


export type GetBuildingQuery = { __typename?: 'Query', getBuilding?: { __typename?: 'Building', buildingId?: string | null, name?: string | null, address?: string | null, address1?: string | null, city?: string | null, country?: string | null, postalCode?: string | null, state?: string | null, type?: string | null, preferences?: { __typename?: 'BuildingPreferences', hasGrid?: boolean | null, hasMonitoring?: boolean | null, hasSmartCharging?: boolean | null } | null } | null };

export type GetBuildingLayoutQueryVariables = Exact<{
  buildingId: Scalars['ID']['input'];
}>;


export type GetBuildingLayoutQuery = { __typename?: 'Query', getBuildingLayout?: Array<{ __typename?: 'Section', name?: string | null, order?: number | null, parentId?: string | null, sectionId?: string | null, type?: string | null } | null> | null };

export type GetOrganisationForDomainQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type GetOrganisationForDomainQuery = { __typename?: 'Query', getOrganisationForDomain?: { __typename?: 'CustomerForDomainDetails', authOrganisationId: string } | null };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', me?: { __typename?: 'User', userId?: string | null, customer?: { __typename?: 'Customer', customerId?: string | null } | null } | null };

export const GridDistributionCircuitFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"gridDistributionCircuitFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GridDistributionCircuit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circuitId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<GridDistributionCircuitFragmentFragment, unknown>;
export const GetBuildingGridDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuildingGrid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBuilding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"buildingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionBoxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionBoxId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionBoxId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBuildingGridQuery, GetBuildingGridQueryVariables>;
export const GetExtendedBuildingGridDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExtendedBuildingGrid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBuilding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"buildingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"maxPower"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"phases"}}]}},{"kind":"Field","name":{"kind":"Name","value":"distributionBoxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"distributionBoxId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"circuits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circuitId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionBoxId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetExtendedBuildingGridQuery, GetExtendedBuildingGridQueryVariables>;
export const GetGridForPowerOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGridForPowerOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBuilding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"buildingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"solar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consumption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGridForPowerOverviewQuery, GetGridForPowerOverviewQueryVariables>;
export const GetAvailableCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAvailableCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"buildingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}}}]}]}}]} as unknown as DocumentNode<GetAvailableCategoriesQuery, GetAvailableCategoriesQueryVariables>;
export const GetDeviceTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDeviceType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetDeviceInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDevice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}}]}}]} as unknown as DocumentNode<GetDeviceTypeQuery, GetDeviceTypeQueryVariables>;
export const GetDevicesWithCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevicesWithCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDevicesWithCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"buildingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<GetDevicesWithCategoryQuery, GetDevicesWithCategoryQueryVariables>;
export const GetGridDistributionBoxDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGridDistributionBox"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distributionBoxId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGridDistributionBox"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distributionBoxId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distributionBoxId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"distributionBoxId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxPower"}},{"kind":"Field","name":{"kind":"Name","value":"maxCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"maxPowerPerPhase"}},{"kind":"Field","name":{"kind":"Name","value":"maxCurrentPerPhase"}},{"kind":"Field","name":{"kind":"Name","value":"circuits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"gridDistributionCircuitFragment"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"gridDistributionCircuitFragment"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"gridDistributionCircuitFragment"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"gridDistributionCircuitFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"gridDistributionCircuitFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GridDistributionCircuit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circuitId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<GetGridDistributionBoxQuery, GetGridDistributionBoxQueryVariables>;
export const FetchDeltaForPeriodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchDeltaForPeriod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetDeltaForPeriodInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDeltaForPeriod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<FetchDeltaForPeriodQuery, FetchDeltaForPeriodQueryVariables>;
export const GetMinMaxForPeriodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMinMaxForPeriod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetMinMaxForPeriodInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMinMaxForPeriod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<GetMinMaxForPeriodQuery, GetMinMaxForPeriodQueryVariables>;
export const GetWindowedMeasurementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWindowedMeasurements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WindowedMeasurementsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWindowedMeasurements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<GetWindowedMeasurementsQuery, GetWindowedMeasurementsQueryVariables>;
export const GetDeltaForWindowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDeltaForWindow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetDeltaForWindowInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDeltaForWindow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<GetDeltaForWindowQuery, GetDeltaForWindowQueryVariables>;
export const GetBuildingsForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuildingsForUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"buildingId"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasGrid"}},{"kind":"Field","name":{"kind":"Name","value":"hasMonitoring"}},{"kind":"Field","name":{"kind":"Name","value":"hasSmartCharging"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBuildingsForUserQuery, GetBuildingsForUserQueryVariables>;
export const GetBuildingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuilding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBuilding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"buildingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasGrid"}},{"kind":"Field","name":{"kind":"Name","value":"hasMonitoring"}},{"kind":"Field","name":{"kind":"Name","value":"hasSmartCharging"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<GetBuildingQuery, GetBuildingQueryVariables>;
export const GetBuildingLayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuildingLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBuildingLayout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"buildingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<GetBuildingLayoutQuery, GetBuildingLayoutQueryVariables>;
export const GetOrganisationForDomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationForDomain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrganisationForDomain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authOrganisationId"}}]}}]}}]} as unknown as DocumentNode<GetOrganisationForDomainQuery, GetOrganisationForDomainQueryVariables>;
export const GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;